import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';

export class PublicUtils{
    getURLParam(param:string):string {
        let value:string = decodeURIComponent((new RegExp('[?|&]' + param + '=' + '([^&;]+?)(&|#|;|$)').exec(location.search) || [, ""])[1].replace(/\+/g, '%20')) || null;
        return value;
    }

    getIFrameURLParam():string {
        let url = (window.location != window.parent.location) ? document.referrer : document.location.href;
        let value = decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(url) || [, ""])[1].replace(/\+/g, '%20')) || null;
        if (value === null) {
            return '';
        } else {
            return value;
        }
    }

    isAppInIFrame():boolean {
        try {
            return window.self !== window.top;
        } catch (e) {
            return true;
        }
    }

    getEncodedString(params:any){
        let str = '';
        for (let name in params) {
            str += name + '=' + encodeURIComponent(params[name]) + '&'
        }
        let pos = str.length;
        str = str.substring(0, pos - 1) + str.substring(pos, str.length);
        return str;
    }

    getFormatedDate():string{
        let d = new Date();
        let month = d.getMonth();
        month = month + 1;
        return d.getFullYear() + '-' + month + '-' + d.getDate();
    }

    deleteArrayDuplicates(ar):object{
        let ya = false, v = "", aux = [].concat(ar), r = Array();
        for (let i in aux) {
            v = aux[i];
            ya = false;
            for (let a in aux) {
                if (v == aux[a]) {
                    if (ya == false) {
                        ya = true;
                    } else {
                        aux[a] = "";
                    }
                }
            }
        }
        for (let a in aux) {
            if (aux[a] != "") {
                r.push(aux[a]);
            }
        }
        return r;
    }

    orderData($data){
        let arr = [];
        for(let i = 0; i < $data.length; i++){
            let name = $data[i][0].value;
            if(arr[name]){
                if(arr[name][0] == undefined){     
                    $data[i].shift();
                    let obj= arr[name];
                    arr[name] = [];
                    arr[name].push(obj);
                    arr[name].push(this.orderObj($data[i]));
                }else{
                    $data[i].shift();
                    arr[name].push(this.orderObj($data[i]));
                }
            }else{                
                $data[i].shift();
                arr[name] = this.orderObj($data[i]);
            }
        }
        
        return arr;
    }

    orderObj($arr){
        let obj = {};
        for(let i = 0; i < $arr.length; i++ ){
            obj[$arr[i].name.replace("á","a").replace("é","e").replace("í","i").replace("ó","o").replace("ú","u").replace(" ","_")] = $arr[i].value;
        }
        return obj;
    }

    orderFilters($arr){
        let nombres:any = $arr.Nombres;
        let cond:any = $arr.Condicionales;
        let arr:any = [];


        for(var i = 0;i < $arr.length; i++){
            if($arr[i].tipo == "Nombres"){
                nombres = $arr[i];
            }else{
                cond = $arr[i];
            }
        }
        if(cond["tipo_de_programa"] != "N/A"){
            arr[cond["tipo_de_programa"]] = {filter:"programType",name:nombres["tipo_de_programa"],position:cond["tipo_de_programa"]};
        }
        if(cond["modalidad"] != "N/A"){
            arr[cond["modalidad"]] = {filter:"modality",name:nombres["modalidad"],position:cond["modalidad"]};
        }
        if(cond["sede"] != "N/A"){
            arr[cond["sede"]] = {filter:"site",name:nombres["sede"],position:cond["sede"]};
        }
        if(cond["programa"] != "N/A"){
            arr[cond["programa"]] = {filter:"program",name:nombres["programa"],position:cond["programa"]};
        }
        return arr;
    }

    getLP($arr){
        let arr = $arr;
        let lp:any = this.getURLParam("LP");//window.location.href;
        if(lp == null){
            let arr_url = window.location.pathname.split("/");
            arr_url.shift();
            lp = arr_url.join("/");
        }
        var arr_obj = {};
        for(let  i = 0; i < arr.length; i++ ){
            let name = arr[i][8].value;
            if(arr[i][8].name != "Url landing"){
                name = arr[i][16].value;
            }
            if(lp == name){
                let obj = {};
                for(let j = 0; j < arr[i].length; j++){
                    obj[arr[i][j].name.toLowerCase().split(" ").join("_")] = arr[i][j].value;
                }
                if(arr[i][8].name != "Url landing"){
                    arr_obj[obj["tipo"]] = obj;    
                }else{
                    arr_obj = obj;    
                }
            }
        }
        return arr_obj;
        
    }

    getDatalayer($arr){
        let arr = $arr;
        let response = []
        arr.forEach(element => {
            let data = []
            response[element.form] = []
            
            for (let i = 0; i < element.data.length; i++) {
                if (element.form =='programasNC'){
                    data.push({"name":element.data[i][0].value,"nameCorto":element.data[i][1].value, "code":element.data[i][2].value});
                }
                else
                    data.push({"name":element.data[i][0].value,"code":element.data[i][1].value});
            }
            response[element.form] = data
        });
        return response
    }

    orderPrograms($content, $progs){
        let arr_rtn = [];
        for(let i = 0; i < $content.length; i++){
            let obj = this.orderObj($content[i]);
            let centinela = false;
            for(let j = 0; j < $progs.length && centinela == false; j++){
                //if($progs[j].status == "ACT" && $progs[j].code == obj["Codigo"]){
                    if( $progs[j].code == obj["Codigo"]){    
                    centinela = true;
                    const returnedTarget = Object.assign(obj, $progs[j]);
                    arr_rtn.push(returnedTarget);
                }
            }
        }
        return arr_rtn;
    }

    orderProgramsSena($content, $progs,$progSiaf){
        let arr_rtn = [];
        let arr2 = [];
        for(let i = 0; i < $progs.length; i++){
            let obj2= this.orderObj($progs[i]);
            obj2['siaf'] = [];
            let centinela = false;
            for(let j = 0; j < $progSiaf.length && centinela == false; j++){
                if($progSiaf[j].Codigo == $progs[i].code){
                    $progs[i].siaf = [];
                    $progs[i].siaf.push($progSiaf[j]);
                    centinela = true;
                }
            }
        }
        for(let i = 0; i < $content.length; i++){
            let obj = this.orderObj($content[i]);
            let centinela = false;
            obj['programs'] = [];
            for(let j = 0; j < $progs.length && centinela == false; j++){
                var re = new RegExp($progs[j].code, 'g')
                if(obj["codesProgramFUAA"].match(re)){
                    obj['programs'].push($progs[j])
                    const returnedTarget = obj; 
                    arr_rtn.push(returnedTarget);
                }
            }
        }
        let data:any = this.deleteArrayDuplicates(arr_rtn);
        return data;
    }
    orderTypes($data){
        let arr = [];
        for(let i = 0; i < $data.length; i++){
            arr.push($data[i].programType);
        }
        let data:any = this.deleteArrayDuplicates(arr);
        let data_rtn = [];
        for(let  i = 0; i < data.length; i++){
            data_rtn.push({name:this.labelsTypes(data[i]),val:data[i]});
        }
        return data_rtn;
    }

    orderFaculty($data){
        let arr = [];
        for(let i = 0; i < $data.length; i++){
            arr.push($data[i].Facultad);
        }
        let data:any = this.deleteArrayDuplicates(arr);
        let data_rtn = [];
        for(let  i = 0; i < data.length; i++){
            switch(data[i]){
                case 'CAEF':
                    data_rtn.push({val:data[i],name:"Ciencias administrativas,<br>económicas<br>y financieras"});
                break;
                case 'DCBA':
                    data_rtn.push({val:data[i],name:"Diseño,<br>comunicaciones<br>y bellas artes"});
                break;
                case 'CJSH':
                    data_rtn.push({val:data[i],name:"Ciencias jurídicas,<br>sociales<br>y humanísticas"});
                break;
                case 'CS':
                    data_rtn.push({val:data[i],name:"Ciencias<br>de la salud"});
                break;
                case 'EDU':
                    data_rtn.push({val:data[i],name:"Educación"});
                break;
                case 'ICB':
                    data_rtn.push({val:data[i],name:"Ingenierías y ciencias básicas"});
                break;
            }
            
        }
        return data_rtn;
    }

    labelsTypes($code){
        switch($code){
            case 'PRE-PRE':
                return "Pregrado";
                break;
            case 'MAEST-POS':
                return "Maestría";
                break;
            case 'DOC-POS':
                return "Doctorado";
                break;
            case 'PROF-PRE':
                return "Profesional";
                break;
            case 'ESP':
                return "Especial";
                break;
            case 'ESPEC-POS':
                return "Especialización";
                break;
            case 'TECNI-PRE':
                return "Técnico";
                break;
            case 'TECNO-PRE':
                return "Tecnológo";
                break;
            case 'DP-PE':
                return "Diplomado";
                break;
            case 'CC-PE':
                return "Curso";
                break;
            case 'LIC-PRE':
                return "Licenciatura";
                break;
        }
    }
    
    labelsModal($code){
        switch ($code) {
            case 'PRE':
                return 'Presencial'
            break;
            case 'SEMI':
                return 'Semipresencial'
            break;
            case 'DIS':
                return 'Distancia'
            break;
            case 'VIR':
                return 'Virtual'
            break;
        }
    }

}